var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height pa-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"fill-height ma-0",attrs:{"justify":"center","align":"center"}},[_c('loading-screen')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }